import { isTablet, debounce } from '../../utils';

class UniversitiesCarouselAnimation {
  constructor({ carouselContainer, carouselItemsListClass, carouselContainerClass }) {
    this.carouselContainer = carouselContainer;
    this.carouselItemsListClass = carouselItemsListClass;
    this.carouselContainerClass = carouselContainerClass;

    this.addToCarouselNode();

    window.addEventListener(
      'resize',
      debounce(() => {
        isTablet ? this.addToCarouselNode() : this.removeFromCarouselNode(); // eslint-disable-line
      }, 300),
    );
  }

  addToCarouselNode() {
    if (isTablet) {
      const carouselItemsList = document.querySelectorAll(this.carouselItemsListClass);

      if (carouselItemsList.length === 1) {
        const carouselImgList = carouselItemsList[0].cloneNode(true);
        this.carouselContainer.appendChild(carouselImgList);
        this.carouselContainer.classList.add(`${this.carouselContainerClass}--animated`);
      }
    }
  }

  removeFromCarouselNode() {
    const carouselItemsList = document.querySelectorAll(this.carouselItemsListClass);

    if (carouselItemsList.length === 2) {
      this.carouselContainer.classList.remove(`${this.carouselContainerClass}--animated`);
      carouselItemsList[1].remove();
    }
  }
}

export default UniversitiesCarouselAnimation;
